import { useContentStore } from "@/stores/content";
import { defaultPropertyStep } from "./hardCodedValues";
import { BasicPart, ChannelPort, InletOutletLayers } from "./other";
import {
  PayloadCircle,
  PayloadPolygon,
  Point
} from "./payloadPrimitives";
import { BasicPartOutput } from "./typeDefinations";
export class InletOutlet extends BasicPart {
  properties = {
    r1: {
      value: 200,
      name: "Radius of Port",
      step: defaultPropertyStep,
      unit: "µm"
    },
  };
  channelType: number;
  x: number;
  y: number;
  layers: InletOutletLayers;

  get type(): string {
    return "inlet/outlet";
  }
  get vueComponent(): string {
    return "SvgFlowControlNodeVue";
  }
  channelPort = new ChannelPort(0, 0, "");
  private updateChannelPortPosition() {
    this.channelPort.position[0] = this.x;
    this.channelPort.position[1] = this.y;
  }
  constructor(position: number[], r1: number, t: number, layer: string, layers?: InletOutletLayers) {
    super(layer);
    const contentStore = useContentStore();
    this.x = position[0];
    this.y = position[1];
    this.updateChannelPortPosition();
    this.channelType = t;
    this.properties.r1.value = r1;
    if (layers) {
      this.layers = layers;
      this.layers.setupReactivity(true);
    } else {
      this.layers = new InletOutletLayers(layer);
      this.layers.setupReactivity(false);
    }
    InletOutlet.count++;
    while (contentStore.contentMap.has("Port-" + InletOutlet.count)) {
      InletOutlet.count++;
    }
    this.id = "Port-" + InletOutlet.count;
    this.channelPort.elementId = this.id;
  }

  static resetCount(): void {
    InletOutlet.count = 0;
  }
  static parse(content: BasicPartOutput): InletOutlet {
    const res = new InletOutlet(
      content.position,
      content.properties.r1,
      content.channelType,
      content.layer,
      new InletOutletLayers(content.layers.state.bottomLayer, content.layers.layers)
    );
    res.id = res.channelPort.elementId = content.id;
    return res;
  }

  buildOutput(layer: string): BasicPartOutput {
    const properties = new Map();
    for (const [key, value] of Object.entries(this.properties)) {
      properties.set(key, value.value);
    }
    const output = {
      id: this.id,
      position: [this.x, this.y],
      properties: Object.fromEntries(properties),
      channelType: this.channelType,
      layer,
      layers: this.layers
    };
    return output;
  }

  clone(): InletOutlet {
    const copy = new InletOutlet(
      [this.x, this.y],
      this.properties.r1.value,
      this.channelType,
      this.layer,
      this.layers
    );
    const contenStore = useContentStore();
    contenStore.addElmentToContent(copy);
    
    return copy;
  }

  updatePosition(x: number, y: number): void {
    const offsetX = x - this.translate[0];
    const offsetY = y - this.translate[1];
    this.x += offsetX;
    this.y += offsetY;
    this.updateChannelPortPosition();
    this.setTranslate(x, y);
  }
  buildPayload(
    z: number,
    lyr: string,
    wallHeight?: number
  ): { shapes: [PayloadCircle | PayloadPolygon] } | void {
    if (this.properties.r1.value <= 0) {
      throw "invalid radius at " + this.id;
    }
    const contentStore = useContentStore();
    const r1 = this.properties.r1.value;
    let h1 = contentStore.wallHeight;
    this.layers.layers.forEach(layer => {
      if (layer.layer === lyr) {
        if (wallHeight && !layer.modified && lyr === contentStore.getTopLayerId) {
          h1 = wallHeight;
        } else {
          h1 = layer.value;
        }
        
      }
    }); 
    
    if (h1 > 0 && r1 > 0) {
      if (this.channelType === 0) {
        const circle = new PayloadCircle(
          new Point(this.x, this.y, z, contentStore.chipLengthY),
          true,
          h1,
          r1
        );
        return { shapes: [circle] };
      } else {
        const s = this.properties.r1.value;
        const p1 = new Point(this.x - s, this.y - s, z, contentStore.chipLengthY);
        const p2 = new Point(this.x + s, this.y - s, z, contentStore.chipLengthY);
        const p3 = new Point(this.x + s, this.y + s, z, contentStore.chipLengthY);
        const p4 = new Point(this.x - s, this.y + s, z, contentStore.chipLengthY);
        const poly = new PayloadPolygon([p1, p2, p3, p4], true, 0, 0, h1);
        return { shapes: [poly] };
      }
    }
  }
}